import { forwardRef } from 'react'
import { cn } from './cnNew'

const VARIANTS = {
  primary: 'bg-primary text-primary-foreground hover:bg-primary/90 border border-transparent',
  secondary:
    'bg-primary-soft text-primary hover:bg-primary/15 border border-transparent font-medium',
  outline: 'bg-card text-foreground border border-input hover:bg-muted',
  ghost: 'bg-transparent text-muted-foreground hover:bg-muted hover:text-foreground border border-transparent',
  danger: 'bg-transparent text-destructive hover:bg-destructive/10 border border-transparent',
}

const SIZES = {
  sm: 'h-[32px] px-[16px] text-[13px] gap-[6px] rounded-md',
  md: 'h-[40px] px-[24px] text-[14px] gap-[8px] rounded-lg',
  lg: 'h-[44px] px-[28px] text-[15px] gap-[10px] rounded-lg',
  icon: 'h-[32px] w-[32px] rounded-md justify-center',
  'icon-lg': 'h-[40px] w-[40px] rounded-lg justify-center',
}

export const Button = forwardRef(function Button(
  { variant = 'outline', size = 'md', className, type = 'button', ...props },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(
        'inline-flex items-center justify-center font-medium whitespace-nowrap transition-colors select-none',
        'disabled:pointer-events-none disabled:opacity-50',
        VARIANTS[variant],
        SIZES[size],
        className
      )}
      {...props}
    />
  )
})

/** Botón de icono con etiqueta accesible obligatoria. */
export function IconButton({ label, size = 'icon', className, children, ...props }) {
  return (
    <Button variant="ghost" size={size} aria-label={label} title={label} className={className} {...props}>
      {children}
    </Button>
  )
}
